import { motion } from "framer-motion";
import { useState, useEffect } from "react";
import { FiChevronLeft, FiChevronRight } from "react-icons/fi";
import useMeasure from "react-use-measure";

const CARD_WIDTH = 350;
const CARD_HEIGHT = 400;
const MARGIN = 20;
const CARD_SIZE = CARD_WIDTH + MARGIN;

const BREAKPOINTS = {
  sm: 640,
  lg: 1024,
  xl: 1536, // Breakpoint pour désactiver le carousel
};

const CardCarousel = () => {
  const [ref, { width }] = useMeasure();
  const [offset, setOffset] = useState(0);
  const [isCarousel, setIsCarousel] = useState(true);

  // Vérifie la largeur pour activer/désactiver le carousel
  useEffect(() => {
    setIsCarousel(width < BREAKPOINTS.xl);
  }, [width]);

  const CARD_BUFFER =
    width > BREAKPOINTS.lg ? 3 : width > BREAKPOINTS.sm ? 2 : 1;

  const CAN_SHIFT_LEFT = offset < 0;

  const CAN_SHIFT_RIGHT =
    Math.abs(offset) < CARD_SIZE * (items.length - CARD_BUFFER);

  const shiftLeft = () => {
    if (!CAN_SHIFT_LEFT) {
      return;
    }
    setOffset((pv) => (pv += CARD_SIZE));
  };

  const shiftRight = () => {
    if (!CAN_SHIFT_RIGHT) {
      return;
    }
    setOffset((pv) => (pv -= CARD_SIZE));
  };

  return (
    <section className="bg-white my-20" ref={ref} id="services">
      <div className="relative overflow-hidden p-4">
        <div className="mx-auto max-w-6xl">
          {isCarousel ? (
            <motion.div
              animate={{
                x: offset,
              }}
              transition={{
                type: "spring",
                stiffness: 300,
                damping: 30,
                mass: 0.5,
              }}
              className="flex"
            >
              {items.map((item) => {
                return <Card key={item.id} {...item} />;
              })}
            </motion.div>
          ) : (
            <div className="flex justify-center items-center space-x-5">
              {items.map((item) => {
                return <Card key={item.id} {...item} />;
              })}
            </div>
          )}
        </div>

        {isCarousel && (
          <>
            {/* Boutons pour le carousel */}
            <motion.button
              initial={false}
              className="absolute left-0 top-[60%] z-30 rounded-r-xl bg-[#9BDAF2] p-3 pl-2 text-8xl text-white backdrop-blur-sm transition-[padding] hover:pl-3"
              onClick={shiftLeft}
            >
              <FiChevronLeft size={24} />
            </motion.button>
            <motion.button
              initial={false}
              className="absolute right-0 top-[60%] z-30 rounded-l-xl bg-[#9BDAF2] p-3 pr-2 text-4xl text-white backdrop-blur-sm transition-[padding] hover:pr-3"
              onClick={shiftRight}
            >
              <FiChevronRight size={24} />
            </motion.button>
          </>
        )}
      </div>
      <div className="flex justify-center">
        <a href="#tarifs">
          <button className="mt-10 px-6 py-3 text-btn bg-slate-950 text-white font-semibold rounded-md transition">
            Voir les tarifs
          </button>
        </a>
      </div>
    </section>
  );
};

const Card = ({ url, category, title, description, etiquette }) => {
  return (
    <div>
      <div
        className="flex flex-col relative shrink-0 rounded-t-md bg-white transition-all hover:scale-[1.015] hover:shadow-xl mr-0"
        style={{
          width: CARD_WIDTH,
          height: CARD_HEIGHT,
          marginRight: MARGIN,
          backgroundImage: `url(${url})`,
          backgroundPosition: "center",
          backgroundSize: "cover",
        }}
      >
        <p className="text-h3 font-semibold bg-blue-300/50 text-white mt-4 w-fit px-2 rounded mr-2 self-end">
          {etiquette}
        </p>
      </div>
      <div className="py-5 my-0 mr-5 text-center bg-gray-50 rounded-b-md h-[260px] w-[350px]">
        <p className="px-20 text-crd-title font-sans font-bold text-slate-950 mt-7 uppercase">
          {category}
        </p>
        <p className="px-5 pb-8 mt-3 text-crd-p text-slate-950">{title}</p>
      </div>
    </div>
  );
};

export default CardCarousel;

const items = [
  {
    id: 1,
    url: "/img/food_meeting.webp",
    category: "consultation visio",
    title:
      "Bénéficie d’un plan d’action nutritionnel et sportif efficace et adapté à ton quotidien pour atteindre tes objectifs physiques.",
    description: "En savoir plus",
  },
  {
    id: 2,
    url: "/img/coaching_at_home.webp",
    category: "séance de sport",
    title:
      "Un entraînement sportif adapté et sécurisé, à domicile ou en salle de sport (Fitness Park Chalon sur Saône), avec un coach à l’écoute de tes besoins.",
    description: "En savoir plus",
  },
  {
    id: 3,
    url: "/img/workout_session_home.webp",
    category: "Programme sportif",
    title:
      "Un programme adapté à ta morphologie et tes contraintes qui assurera ta progression physique.",
    description: "En savoir plus",
  },
  {
    id: 4,
    url: "/img/atelier.webp",
    category: "Prestation nutritionnelle ou sportive",
    title:
      "Des ateliers variés sur le thème de la nutrition ou du sport pour sensibiliser à une hygiène de vie saine, tout en renforçant la cohésion d’équipe.",
    description: "En savoir plus",
    etiquette: "Prestation collective",
  },
];
